import { tns } from 'tiny-slider';
import { elementPrototypes, initClickers, setCookie } from './functions';

require('./edit-skin');
require('./quantity');
require('./read-more');
require('./sweet-variations');
require('./dropdown');
require('./quick-view');
require('./lang-selector');
require('./mini-cart');
require('./cart');
require('./wishlist');
require('./linda-girl');
require('./product-terms');
require('./product');
require('./search');
require('./inifite-scroll');
require('./content-builder');
require('./mobile-menu');
require('./popup');
require('./popup-newsletter');
require('./newsletter-user-creation');
require('./account');
require('./skin-care-quiz');
require('./product-sizes');
require('./product-variable');
require('./product-kit-builder');
require('./product-palette-builder');
require('./product-bundle');
require('./thanksyou');
require('./free-gift');
require('./single-video');
require('./edit-subscriptions');
require('./product-loop');
require('./algolia');
require('./checkout');
require('./substance-filter');
require('./b2b');
require('./faq');
require('./revieve');
require('./datalayer');
require('./lnda-lab');
require('./member-status-popup');


window.addEventListener('scroll', () => {
  const fromTop = window.pageYOffset;
  const bodyEl = document.body;

  if (fromTop > 200) {
    bodyEl.classList.add('smaller-header');
  } else {
    bodyEl.classList.remove('smaller-header');
  }
});

window.addEventListener('scroll', () => {
  const fromTop = window.pageYOffset;
  const sticky = document.getElementsByClassName('visible-on-scroll');

  if (sticky.length) {
    for (let i = 0; i < sticky.length; i += 1) {
      const data = {
        scrollLength: '50',
      };

      if (sticky[i].dataset.scrollLength) {
        data.scrollLength = sticky[i].dataset.scrollLength;
      }

      if (fromTop > data.scrollLength) {
        sticky[i].style.opacity = '1';
        sticky[i].classList.add('visible');
      } else {
        sticky[i].style.opacity = '0';
        sticky[i].classList.remove('visible');
      }
    }
  }
});

const isTouch = ('ontouchstart' in document.documentElement) ? 'touch' : 'no-touch';
document.documentElement.classList.add(isTouch);

jQuery(document).on('click', 'a.toggle-faq-term', (e) => {
  e.preventDefault();
  const parent = e.currentTarget.parentNode.parentNode;
  parent.classList.toggle('open');
  jQuery(parent).find('.q-and-a-list').slideToggle();
});

jQuery(document).on('click', '.single-faq-item .question a', (e) => {
  e.preventDefault();
  const parent = e.currentTarget.parentNode.parentNode;
  parent.classList.toggle('open');
  jQuery(parent).find('.answer').slideToggle();
});

function shippingHandler() {
  const radioButtons = document.querySelectorAll('ul#shipping_method input[type="radio"]');
  let buttonsValue;

  radioButtons.forEach((element) => {
    if (element.checked === true) {
      buttonsValue = element.getAttribute('value');
    }
  });

  const radioButtonsBottom = document.querySelectorAll('tr.shipping.recurring-total ul input[type="radio"]');

  radioButtonsBottom.forEach((element) => {
    element.removeAttribute('checked');
    element.parentNode.classList.remove('checked');
    if (element.getAttribute('value') === buttonsValue) {
      element.parentNode.classList.add('checked');
      element.setAttribute('checked', 'checked');
    }
  });
}
jQuery(document).ajaxComplete(() => {
  shippingHandler();
});

jQuery(document).on('ready', shippingHandler);

/**
 * Product archives top navigation.
 */
const maksimerCatNav = () => {
  const container = document.querySelector('.maksimer-cat-nav');
  if (container) {
    const list = container.querySelector('ul');
    const active = container.querySelector('ul li.active');
    if (active) {
      list.prepend(active);
    }
  }
}; maksimerCatNav();

jQuery(document).on('click', '.approve-priv', (event) => {
  event.preventDefault();
  document.querySelector('#priv-notice').remove();
  setCookie('privacyAccepted', 1, 730);
  // eslint-disable-next-line no-restricted-globals
  // location.reload();
});

const calculateStickyHeaderPadding = () => {
  const app = document.getElementById('app');
  const header = document.getElementById('theme-header');
  const wpadminbar = document.getElementById('wpadminbar');

  let padding = 0;

  padding += header.offsetHeight;

  if (wpadminbar) {
    padding += wpadminbar.offsetHeight;
  }

  app.style.paddingTop = `${padding}px`;
};

setTimeout(() => {
  calculateStickyHeaderPadding();
}, 10);
window.addEventListener('resize', calculateStickyHeaderPadding);
window.addEventListener('scroll', () => {
  if (window.pageYOffset === 0) {
    setTimeout(calculateStickyHeaderPadding, 500);
  }
});


const initYoutubeOffload = () => {
  const videoContainers = Array.from(document.querySelectorAll('.video-loader-wrapper'));
  if (videoContainers) {
    videoContainers.forEach((videoContainer) => {
      const playButton = videoContainer.querySelector('.play-button');
      if (playButton) {
        playButton.addEventListener('click', (event) => {
          event.preventDefault();
          const { url } = playButton.dataset;

          if (url) {
            const payload = {
              action: 'maksimer_get_video',
              url,
            };
            // eslint-disable-next-line no-undef
            jQuery.post(translation.ajaxurl, payload, (response) => {
              // eslint-disable-next-line no-param-reassign
              videoContainer.innerHTML = response;
            });
          }
        });
      }
    });
  }
};
initYoutubeOffload();
jQuery(document.body).on('variable-product-changed-product', initYoutubeOffload);

const zendeskCustomIconInit = setInterval(() => {
  const launcherIframe = document.querySelector('#launcher');

  if (launcherIframe) {
    setTimeout(() => {
      const customButton = document.getElementById('toggle-customer-service');

      if (customButton) {
        customButton.classList.remove('hidden');
        customButton.addEventListener('click', (event) => {
          event.preventDefault();

          if (launcherIframe) {
            const button = launcherIframe.contentWindow.document.querySelector('button[data-testid="launcher"]');
            button.click();
          }
        });
      }
    }, 500);
    clearInterval(zendeskCustomIconInit);
  }
}, 1000);


const headerTicker = () => {
  const ticker = document.querySelector('.header-selling-points.ticker');
  if (ticker) {
    const list = ticker.querySelector('ul');
    const listItems = Array.from(ticker.querySelectorAll('li'));
    ticker.classList.add(`items-${listItems.length}`);

    const clone = listItems[0].cloneNode(true);
    list.append(clone);
  }
};
headerTicker();

const headerFadeAnimation = () => {
  const container = document.querySelector('.header-selling-points.fade');

  if (container) {
    const loopAnimation = () => {
      const active = container.querySelector('li.active');
      active.classList.remove('active');
      let nextRow = active.nextElementSibling;
      if (!nextRow) {
        nextRow = container.querySelector('ul li');
      }
      nextRow.classList.add('active');
    };

    setInterval(loopAnimation, 3000);
  }
};
headerFadeAnimation();

// Add slide functions to HTML Elements
elementPrototypes();

window.addEventListener('load', () => {
  initClickers();

  // Init tiny slider on my account membership page
  tns({
    container: '.membership-compare-levels__inner',
    items: 1,
    controls: false,
    nav: false,
    gutter: 30,
    edgePadding: 50,
    mouseDrag: true,
    responsive: {
      768: {
        items: 3,
      },
      992: {
        items: 4,
      },
    },
  });
});
